import script from "./PUR08_004INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR08_004INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR08_004INS.vue?vue&type=style&index=0&id=b405be94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b405be94"]])

export default __exports__